module.exports = __webpack_public_path__ + "img/search.940c397d.png";